import { Component, OnInit, ViewChild } from '@angular/core';
import { StreetService } from '../../../../../services/street.service';
import { DistrictService } from '../../../../../services/district.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { District, IDistrict } from '../../../../../models/district.model';
import { Validation } from '../../../error/error-messages/validator-messages';
import Swal from 'sweetalert2';
import { Street } from '../../../../../models/street.model';

@Component({
  selector: 'app-street',
  templateUrl: './street.component.html',
  styleUrls: ['./street.component.scss']
})
export class StreetComponent implements OnInit {

  @ViewChild('closebutton') closebutton;
  @ViewChild('closebutton2') closebutton2;

  // @ts-ignore
  street: IStreet[] = [];
  district: IDistrict[] = [];
  // @ts-ignore
  currentStreet: IStreet = [];

  search: any;
  page = 1;
  perPage = 10;

  sorted = false;
  sorted1 = false;
  sorted2 = false;

  constructor(private fb: FormBuilder, private streetService: StreetService, private districtService: DistrictService) { }

  ngOnInit(): void {
    this.loadStreet();
    this.loadDistrict();
  }


  get f() { return this.streetForm.controls; }
  get f1() { return this.editStreetForm.controls; }

  streetForm = this.fb.group({
    name: new FormControl('',  [ Validation.requiredValidator("Le nom"),]),
    district: new FormControl('',  [ Validation.requiredValidator("Le discrict"),]),
    description: new FormControl('',  ),
  });

  editStreetForm = this.fb.group({
    name: new FormControl('', [ Validators.required]),
    district: new FormControl('', [ Validators.required]),
    description: new FormControl('', ),
  });

  loadStreet = () => {
    this.streetService.getStreet()
      .subscribe((data: any) => {
        //console.log(data);
        this.street = data.content;
      }, (err) => {
       // console.log('-----> err', err);
      });
  }

  loadDistrict() {
    this.districtService.getDistrict()
      .subscribe((data: any) => {
        data.content.forEach((element: any) => {
          this.district.push(element);
        });
        // this.district = data;
      }, (err) => {
       // console.log('-----> err', err);
      });
  }

  onStreetFormSubmit() {
   // console.log(this.streetForm.value);
    const street: Street = this.streetForm.value;
    street.district = this.getDistrict(this.streetForm.controls['district'].value);
    this.streetService.saveStreet(street).subscribe(rs => {
      //console.log(rs);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Rue ajoutée avec succés"',
        showConfirmButton: false,
        timer: 1500
      });
      this.close();
      this.loadStreet();
    }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez vérifier les données',
        showConfirmButton: false,
        timer: 2500
      });
    });

  }

  deleteStreet(id: any) {
    Swal.fire({
      title: 'SUPPRESSION',
      text: 'Voulez-vous vraiment supprimer cette rue ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'OUI',
      denyButtonText: `NON`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.streetService.deleteStreet(id).subscribe(
        rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Rue supprimée avec succés"',
            showConfirmButton: false,
            timer: 1500
          });
          this.loadStreet();        }
      );
      } else if (result.isDenied) {
        Swal.fire({
          icon: 'error',
          text: 'Suppression annulée',

        })
      }
    })
  }

  onEditStreet(id: any) {
    this.streetService.getidStreet(id).subscribe(rs => {
      this.currentStreet = rs;
      this.editStreetForm = this.fb.group({
        id: new FormControl(this.currentStreet.id, [ ]),
        name: new FormControl(this.currentStreet.name,
          [Validators.required, Validators.minLength(2),
          Validators.pattern('^[A-Za-z -]+$')]),
        description: new FormControl(this.currentStreet.description, [ Validators.required, Validators.minLength(2), Validators.pattern('^[A-Za-z -]+$')]),
        district: new FormControl(this.currentStreet.district, [ Validators.required] ),
      });
      // @ts-ignore
      this.editStreetForm.get('district').setValue(this.currentStreet.district?.id);
    });
  }

  onEditStreetFormSubmit() {
   // console.log(this.editStreetForm.value);
    const street: Street = this.editStreetForm.value;

    street.district = this.getDistrict(this.editStreetForm.controls['district'].value);
    this.streetService.updateStreet(street).subscribe(rs => {
      //console.log(rs);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Rue modifiée avec succés"',
        showConfirmButton: false,
        timer: 1500
      });
      this.close();
      this.loadStreet();
      }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez vérifier les données',
        showConfirmButton: false,
        timer: 2500
      });
    });
  }

  getDistrict(id: any): District {
    let district: District = new District();
    this.district.forEach(value => {
      if (value.id == id) {
        district = value;
      }
    });
    return district;
  }

  onViewStreet(id: any) {
    this.streetService.getidStreet(id).subscribe(rs => {
      this.currentStreet = rs;
    });
  }

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
   // console.log(this.perPage);
  }

  searchFilter($event: KeyboardEvent) {
   // console.log(this.search);
    this.streetService.getStreet().subscribe(data => {
      this.street = data.content;
      this.street = this.street.filter(value =>
        value.name?.toUpperCase().includes(this.search) || value.name?.toLowerCase().includes(this.search)
      );
    }, (err) => {
      //console.log('-----> err', err);
    });
  }

  sort1() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.street.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.street.sort((a, b) => a.name < b.name ? 1 : a.name > b.name ? -1 : 0)
      this.sorted1 = false;
    }
  }

  sort2() {
    if(this.sorted2 == false) {
      // @ts-ignore
      this.street.sort((a, b) => a.district?.name > b.district?.name ? 1 : a.district?.name < b.district?.name ? -1 : 0)
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.street.sort((a, b) => a.district?.name < b.district?.name ? 1 : a.district?.name > b.district?.name ? -1 : 0)
      this.sorted2 = false;
    }
  }

  close() {
    this.closebutton.nativeElement.click();
    this.closebutton2.nativeElement.click();
  }

}
